module.exports = __webpack_public_path__ + "img/ossetia.f6293ecb.svg";